import React, {Component} from 'react';
import h from 'react-hyperscript';
import './GraphTooltip.scss';

class GraphTooltip extends Component {
  constructor(props) {
    super(props);
    this.tooltipRef = React.createRef();
    this.tooltipContainerRef = React.createRef();
    this.arrowRef = React.createRef();
    this.arrowIconRef = React.createRef();
    this.state = {
      active: false,
      value: props.value,
    };
  }

  componentDidMount() {
    this.setRef(this.props.setRef, this.props.id);
  }

  setRef(setRef, id) {
    if (setRef && id) {
      setRef(id, this);
    }
  }

  componentDidUpdate() {
    this.setRef(this.props.setRef, this.props.id);
  }

  makeActive() {
    this.setState({
      active: true,
    });
  }

  makeInactive() {
    this.setState({
      active: false,
    });
  }

  setPosition(x, y, bounds, {canInvert=false, padding={}}={}) {
    const {x: xB=0, y: yB=0, width, height} = bounds;
    const {x: paddingX=20, y: paddingY=24} = padding;
    const {offsetWidth, offsetHeight} = this.tooltipRef.current;
    const leftBound = x - ((offsetWidth / 2) + paddingX);
    const topBound = y - (offsetHeight + paddingY);
    const rightBound = x + ((offsetWidth / 2) + paddingX);
    const bottomBound = y + paddingY;

    const arrowIconPadding = 15;

    const pastLeft = -1 * (leftBound + xB);
    const pastRight = (xB + width) - rightBound;
    const pastTop = -1 * (topBound + yB);
    const pastBottom = (yB + height) - bottomBound;

    const isPastLeft = pastLeft > 0;
    const isPastRight = pastRight < 0;

    let offsetX = isPastLeft ? pastLeft : pastRight < 0 ? pastRight : 0;
    let offsetY = pastTop > 0 ? pastTop : pastBottom < 0 ? pastBottom : 0;

    const arrowAdjustLimitX = (offsetWidth / 2) - arrowIconPadding;

    if (offsetX > arrowAdjustLimitX) {
      this.arrowIconRef.current.style.transform =
        `skewX(-31.33deg) translateX(calc(-1 * (50% - 3px))`;
      offsetX -= arrowIconPadding;
    } else if (offsetX < -arrowAdjustLimitX) {
      this.arrowIconRef.current.style.transform =
        `skewX(31.33deg) translateX(calc(50% - 23px))`;
      offsetX -= arrowIconPadding;
    } else if (isPastLeft) {
      this.resetArrowIcon();
      offsetX -= arrowIconPadding;
    } else if (isPastRight) {
      this.resetArrowIcon();
      offsetX -= arrowIconPadding;
    } else {
      this.resetArrowIcon();
    }

    if (canInvert) {
      const arrowAdjustLimitY = offsetHeight + 20;
      if (y < arrowAdjustLimitY) {
        this.setState({inverted: true});
        offsetY = offsetHeight + 40;
      } else {
        this.setState({inverted: false});
      }
    }

    this.tooltipRef.current.style.transform =
      `translate(${(x || '0') + offsetX}px, ${(y || '0') + offsetY}px)`;
    this.arrowRef.current.style.transform =
      `translateX(${-1 * offsetX}px)`;
  }

  setValue(value) {
    this.setState({
      value,
    });
  }

  resetArrowIcon() {
    this.arrowIconRef.current.style.transform = 'translateX(-50%)';
  }

  render() {
    const {active, value, inverted} = this.state;
    const {icon, title} = this.props;

    const components = [
      h('p', {
        className: 'graph-tooltip__title',
      }, [
        title,
        h('span', {
          className: 'graph-tooltip__value',
        }, value),
      ]),
      h('div', {
        className: 'graph-tooltip__arrow',
        ref: this.arrowRef,
      }, h('div', {
        className: 'graph-tooltip__arrow__icon',
        ref: this.arrowIconRef,
      })),
    ];

    if (icon) {
      components.unshift(
          h('img', {
            className: 'graph-tooltip__icon',
            width: 24,
            srcSet: `${icon.standard} 1x, ${icon.retina} 2x`,
          })
      );
    }

    return (
      h('div', {
        className: `
          graph-tooltip
          ${active ? ' active' : ''}
          ${inverted ? ' inverted' : ''}
        `,
        ref: this.tooltipRef,
      }, h('div', {
        className: 'graph-tooltip__container',
        ref: this.tooltipContainerRef,
      }, components))
    );
  }
}

export default GraphTooltip;
